const colors = {
    mathLowDark: "#06D6A0",
    mathLowLight: "rgb(230 251 245)",
    mathMidDark: "#EF476F",
    mathMidLight: "rgb(250 235 240)",
    mathHighDark: "#FFD166",
    mathHighLight: "rgb(253, 250, 239)",
    lanLowDark: "#06D6A0",
    lanHighDark: "#EF476F",
    lanHighLight: "rgb(250 235 240)",
    lanLowLight: "rgb(230 251 245)",
    lightGrey: "#00000029",
    blue: "#118AB2",
}
export default colors;


// WEBPACK FOOTER //
// ./src/styles/colors.js